import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  Card,
  CardContent,
  Grid,
  Autocomplete,
  TextField,
  Stack,
  Button,
  LinearProgress,
} from "@mui/material";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import ApiMap from "../../utils/ApiMap";
import AuthService from "../../utils/AuthService";
import { groupBy } from "../../utils/Uitils";

// const Assignment = ({ assignments }) => {
//   const navigate = useNavigate();

//   return (
//     <Stack spacing={1} sx={{ px: 1 }}>
//       {assignments.map((a, i) => (
//         <Grid
//           container
//           key={i}
//           spacing={1}
//           sx={{ borderBottom: "1px solid #eee", pb: 1 }}
//         >
//           <Grid item xs={4}>
//             <Typography fontWeight="bold">{a.LessonName}</Typography>
//             <Typography variant="caption" color="text.secondary">
//               {a.Module}
//             </Typography>
//           </Grid>
//           <Grid item xs={2} textAlign="center">
//             <Typography variant="caption">
//               {new Date(a.DateCompleted).toLocaleDateString("en-GB", {
//                 day: "2-digit",
//                 month: "short",
//                 year: "2-digit",
//               })}
//             </Typography>
//           </Grid>
//           <Grid item xs={2} textAlign="center">
//             <Typography variant="caption">
//               {new Date(a.DateCompleted).toLocaleDateString("en-GB", {
//                 day: "2-digit",
//                 month: "short",
//                 year: "2-digit",
//               })}
//             </Typography>
//           </Grid>
//           <Grid item xs={2} textAlign="center">
//             <Typography variant="body2" fontWeight="500">
//               {a.GradeObtained}
//             </Typography>
//           </Grid>
//           <Grid item xs={2} textAlign="center">
//             <Button
//               variant="outlined"
//               size="small"
//               onClick={() =>
//                 navigate("/coursepage", {
//                   state: {
//                     lessonName: a.LessonName,
//                     courseId: a.CourseId,
//                     chapterId: a.ChapterId,
//                     moduleId: a.ModuleId,
//                     contentId: a.Id,
//                     openforstudent: a.OpenForStudent,
//                     resubmit: a.Resubmit,
//                     lessonType: a.ContentType,
//                     datefinished: a.DateCompleted,
//                     // You can add more if required
//                   },
//                 })
//               }
//             >
//               Open
//             </Button>
//           </Grid>
//         </Grid>
//       ))}
//     </Stack>
//   );
// };

const DisplayAssignment = ({ assignments }) => {
  const userAssignments = groupBy(assignments, "MemberId");
  const [filteredAssignments, setFilteredAssignments] =
    useState(userAssignments);
  const navigate = useNavigate();

  const students = Object.keys(userAssignments).map((id) => {
    const entry = userAssignments[id][0];
    return {
      id,
      name: `${entry.FirstName} ${entry.LastName}`,
    };
  });

  const handleStudentSelect = (event, selected) => {
    setFilteredAssignments(
      selected
        ? { [selected.id]: userAssignments[selected.id] }
        : userAssignments
    );
  };

  const formatDate = (date) =>
    new Date(date).toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "short",
      year: "2-digit",
    });

  return (
    <Box p={3}>
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        mb={3}
      >
        <Typography variant="h5" fontWeight={600}>
          Assignments to Grade
        </Typography>
        <Autocomplete
          options={students.sort((a, b) => a.name.localeCompare(b.name))}
          getOptionLabel={(option) => option.name}
          onChange={handleStudentSelect}
          sx={{ width: 300 }}
          renderInput={(params) => (
            <TextField {...params} label="Filter by Student" />
          )}
        />
      </Stack>

      {Object.keys(filteredAssignments).map((id) => {
        const student = filteredAssignments[id][0];
        const records = filteredAssignments[id];

        return (
          <Card
            key={id}
            variant="outlined"
            sx={{ mb: 2, borderRadius: 2, boxShadow: 1 }}
          >
            <CardContent sx={{ p: 0 }}>
              {/* Header: Name + Course */}
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  backgroundColor: "#1976d2",
                  color: "#fff",
                  px: 2,
                  py: 1,
                  borderTopLeftRadius: 8,
                  borderTopRightRadius: 8,
                }}
              >
                <Typography fontWeight={600}>
                  {student.FirstName} {student.LastName}
                </Typography>
                <Typography variant="body1"> {student.CourseName}</Typography>
              </Box>

              {/* Table Header */}
              {/* Table Header */}
              <Grid
                container
                sx={{
                  px: 2,
                  py: 1,
                  backgroundColor: "#f5f5f5",
                  textAlign: "center",
                }}
              >
                <Grid item xs={4} sx={{ textAlign: "left" }}>
                  <Typography
                    variant="subtitle2"
                    fontWeight="bold"
                    sx={{ whiteSpace: "normal", wordWrap: "break-word" }}
                  >
                    Lesson
                  </Typography>
                </Grid>
                <Grid item xs={2}>
                  <Typography
                    variant="subtitle2"
                    fontWeight="bold"
                    sx={{ whiteSpace: "normal", wordWrap: "break-word" }}
                  >
                    Completed
                  </Typography>
                </Grid>
                <Grid item xs={2}>
                  <Typography
                    variant="subtitle2"
                    fontWeight="bold"
                    sx={{ whiteSpace: "normal", wordWrap: "break-word" }}
                  >
                    Submitted
                  </Typography>
                </Grid>
                <Grid item xs={2}>
                  <Typography
                    variant="subtitle2"
                    fontWeight="bold"
                    sx={{ whiteSpace: "normal", wordWrap: "break-word" }}
                  >
                    Grade
                  </Typography>
                </Grid>
                <Grid item xs={2}>
                  <Typography
                    variant="subtitle2"
                    fontWeight="bold"
                    sx={{ whiteSpace: "normal", wordWrap: "break-word" }}
                  >
                    Action
                  </Typography>
                </Grid>
              </Grid>

              {/* Rows */}
              {records.map((a, idx) => (
                <Grid
                  container
                  key={idx}
                  sx={{
                    px: 2,
                    py: 1,
                    borderTop: "1px solid #eee",
                    alignItems: "center",
                  }}
                >
                  <Grid item xs={4}>
                    <Typography fontWeight={500}>{a.LessonName}</Typography>
                    <Typography variant="caption" color="text.secondary">
                      {a.Module}
                    </Typography>
                  </Grid>
                  <Grid item xs={2} textAlign="center">
                    <Typography variant="caption">
                      {formatDate(a.DateCompleted)}
                    </Typography>
                  </Grid>
                  <Grid item xs={2} textAlign="center">
                    <Typography variant="caption">
                      {formatDate(a.DateSubmitted)}
                    </Typography>
                  </Grid>
                  <Grid item xs={2} textAlign="center">
                    <Typography variant="body2">{a.GradeObtained}</Typography>
                  </Grid>
                  <Grid item xs={2} textAlign="center">
                    <Button
                      variant="contained"
                      size="small"
                      sx={{ textTransform: "none", fontWeight: 400 }}
                      onClick={() =>
                        navigate(
                          `/Modules/Course/${a.CourseId}/Module/${a.ModuleId}/Chapter/${a.ChapterId}/Lesson/${a.Id}`,
                          {
                            state: {
                              lessonName: a.LessonName,
                              contentId: a.Id,
                              courseId: a.CourseId,
                              moduleId: a.ModuleId,
                              courseName: a.CourseName,
                            },
                          }
                        )
                      }
                    >
                      Grade
                    </Button>
                  </Grid>
                </Grid>
              ))}
            </CardContent>
          </Card>
        );
      })}
    </Box>
  );
};

export default function AssignmentsToGrade() {
  const { courseId } = useParams();
  const [assignments, setAssignments] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const resp = await axios(
          `${ApiMap.CRS_ASSIGNMENTS_GRADING_DUE}/${courseId}`,
          AuthService.getAuthHeader()
        );
        setAssignments(resp.data.UnGradedAssignments || []);
      } catch (error) {
        console.error("Error fetching assignments:", error);
      }
    };
    fetchData();
  }, [courseId]);

  if (!assignments) {
    return (
      <Box
        sx={{
          mt: 4,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <Typography sx={{ mb: 2 }}>Loading assignments...</Typography>
        <LinearProgress
          color="secondary"
          sx={{ width: "60%", maxWidth: 400, mx: "auto" }}
        />
      </Box>
    );
  }

  return <DisplayAssignment assignments={assignments} />;
}
